export function buildTooltipContent({
  fullName,
  fileSize,
  version,
  rendererName,
  rendererVersion,
  itemFileVersions = [],
  fileCount,
}) {
  const tooltipParts = []

  if (fullName) {
    tooltipParts.push(fileCount > 1 ? `${fullName} | ${fileCount} files` : fullName)
  }

  if (itemFileVersions.length > 0) {
    // Filter items that have rendererName
    const itemsWithRenderer = itemFileVersions.filter(({rendererName: name}) => !!name)

    if (itemsWithRenderer.length > 0) {
      // Show only items with renderer info
      itemsWithRenderer.forEach((itemFileVersion) => {
        const itemTooltipParts = []

        if (itemFileVersion.version) {
          itemTooltipParts.push(`Version: ${itemFileVersion.version}`)
        }

        const rendererParts = [
          itemFileVersion.rendererName,
          itemFileVersion.rendererVersion,
        ].filter(Boolean)

        if (rendererParts.length > 0) {
          itemTooltipParts.push(`Renderer: ${rendererParts.join(' ')}`)
        }

        if (itemTooltipParts.length > 0) {
          tooltipParts.push(itemTooltipParts.join(' - '))
        }
      })
    } else {
      // No renderer info, show only one version line
      const firstVersion = itemFileVersions.find(item => item.version)
      if (firstVersion) {
        tooltipParts.push(`Version: ${firstVersion.version}`)
      }
    }
  } else {
    if (version) {
      tooltipParts.push(`Version: ${version}`)
    }

    const rendererParts = [
      rendererName,
      rendererVersion,
    ].filter(Boolean)

    if (rendererParts.length > 0) {
      tooltipParts.push(`Renderer: ${rendererParts.join(' ')}`)
    }
  }

  if (fileSize) {
    tooltipParts.push(`File Size: ${fileSize}`)
  }

  return tooltipParts.join('<br />')
}
